import { gql } from '@apollo/client';

export const GET_SIGNED_URL_QUERY = gql`
  query GetSignedURLQuery($data: GetSignedUrlInput!) {
    getSignedURL(data: $data)
  }
`;
